import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTimesheetFlow } from "@/features/timesheetFlow/useTimesheetFlow";
import { useProjectOverview } from "@/projectOverview/useProjectOverview";
import { DocumentChainDialog } from "@/pages/dokumente/DocumentChainDialog";
import { useDocumentEditor } from "@/pages/dokumente/useDocumentEditor";

/**
 * Öffnet die Dokumentenkette bei `?kette=<docId>` (z. B. zweites Electron-Fenster)
 * und entfernt den Parameter danach.
 *
 * Muss innerhalb von TimesheetFlowProvider / DocumentEditorProvider laufen.
 */
export function DocumentChainDeepLinkBridge() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [chainDocId, setChainDocId] = useState<number | null>(null);
  const { open: openEditor } = useDocumentEditor();
  const { close: closeTimesheet } = useTimesheetFlow();
  const { close: closeProject } = useProjectOverview();

  useEffect(() => {
    const raw = searchParams.get("kette");
    if (!raw) return;
    const id = Number(raw);
    if (!Number.isFinite(id) || id <= 0) return;

    closeTimesheet();
    closeProject();
    setChainDocId(id);
    const next = new URLSearchParams(searchParams);
    next.delete("kette");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, closeTimesheet, closeProject]);

  return (
    <DocumentChainDialog
      open={chainDocId != null}
      onClose={() => setChainDocId(null)}
      docId={chainDocId}
      currentDocId={chainDocId}
      onOpenDocument={(nextId) => {
        setChainDocId(null);
        openEditor({ docId: nextId });
      }}
    />
  );
}
